import { Layout, Tabs, TabsProps } from 'antd';
import React, { useMemo, useState } from 'react';
import { AffirmationsChecklist, SharedCaseAffirmationsAudit } from '../../../../../shared/affirmations-checklist/affirmations-checklist';
import {
  CasesSendReportV1ChecklistContainerSendReportCaseV1FieldsFragment,
  SendReportCaseV1CaseDetailsApplicationReviewAffirmation,
  SendReportCaseV1CaseDetailsApplicationReviewInput
} from '../../../../../../generated';
import { ReviewDocumentsButtonContainer } from './review-documents-button-container';



export interface ChecklistProps {
  data: CasesSendReportV1ChecklistContainerSendReportCaseV1FieldsFragment;
  isSuccess: boolean;
  onSave: (values: SendReportCaseV1CaseDetailsApplicationReviewInput) => Promise<void>;
}

export const SendCaseAffirmationsFieldNames = {
  DESTINATION_ACCEPTABLE: 'Destination acceptable',
  REPORT_COMPILED: 'Report compiled',
  REPORT_SENT: 'Report sent'
};

export const Checklist: React.FC<ChecklistProps> = (props) => {
  const [activeTab, setActiveTab] = useState('1');

  const stripFieldsForAffirmations = (data: SendReportCaseV1CaseDetailsApplicationReviewAffirmation) => {
    if (!data) {
      return {
        isDestinationAcceptable: null,
        isReportCompiled: null,
        isReportSent: null
      };
    }
    const { audit, __typename, ...rest } = data;
    return rest;
  };

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  const fieldNamesMap = useMemo(
    () =>
      new Map<string, string>([
        ['isDestinationAcceptable', SendCaseAffirmationsFieldNames.DESTINATION_ACCEPTABLE],
        ['isReportCompiled', SendCaseAffirmationsFieldNames.REPORT_COMPILED],
        ['isReportSent', SendCaseAffirmationsFieldNames.REPORT_SENT]
      ]),
    []
  );
  const tabItems: TabsProps['items'] = [
    {
      key: '1',
      label: 'Application',
      children: (
        <AffirmationsChecklist
          affirmations={
            stripFieldsForAffirmations(
              props.data?.caseDetails?.applicationReview?.affirmations as SendReportCaseV1CaseDetailsApplicationReviewAffirmation
            ) as SendReportCaseV1CaseDetailsApplicationReviewAffirmation
          }
          audit={props.data?.caseDetails?.applicationReview?.affirmations?.audit as SharedCaseAffirmationsAudit}
          fieldName="affirmations"
          onSave={props.onSave}
          fieldNamesMap={fieldNamesMap}
          state={props.data.state}
          disabled={
            !props.data.isCurrentUserAssigned || 
            props.data.state === 'draft' ||
            props.data.state === 'decisionRendered' ||
            (props.data.state === 'revisionRequested' && props.data.isCurrentUserAssigned)
          }
          isSuccess={props.isSuccess}
        />
      )
    }
  ];
  return (
    <Layout
      style={{
        borderRadius: '10px'
      }}
    >
      <ReviewDocumentsButtonContainer caseId={props.data.id} />
      <Tabs defaultActiveKey="1" items={tabItems} activeKey={activeTab} onChange={handleTabChange} />
    </Layout>
  );
};
